
import { TObject } from "../../../common/TObject";
import { calculateGeometry } from "../../../common/GoogleObjects";
import { Drawing } from "../Drawing";
import { FeatureType } from "./Features";
import { GoogleFeature } from "./GoogleFeature";
import { Feature } from "./Feature";



export class LabelFeature extends GoogleFeature {
    label: any = null; //MapLabel
    selectdiv: HTMLDivElement;
    controlsDiv: HTMLDivElement;
    input: HTMLInputElement;
    canvas: any = null;
    type: FeatureType = FeatureType.LABEL;


    constructor(parent: Drawing, readonly: boolean) {
        super(parent, null, readonly);
        this.label = new google.maps.OverlayView();

        this.label.set('text', '');
        this.label.set('fontFamily', 'sans-serif');
        this.label.set('fontSize', 12);
        this.label.set('fontColor', '#000000');
        this.label.set('strokeWeight', 4);
        this.label.set('strokeColor', '#ffffff');
        this.label.set('align', 'center');

        this.label.set('zIndex', 1e3);

        this.label.setMap(this.map);




        this.label.changed = (prop) => {
            switch (prop) {
                case 'fontFamily':
                case 'fontSize':
                //  this.label.set('fontSize', resizeInput.value);
                case 'fontColor':
                case 'strokeWeight':
                case 'strokeColor':
                case 'align':
                case 'text':
                    return this.drawCanvas_();
                case 'maxZoom':
                case 'minZoom':
                case 'position':
                case 'visibility':
                    return this.draw();
            }
        };



        this.label.type = FeatureType.LABEL;
        this.type = FeatureType.LABEL;
        this.label.onAdd = () => {
            this.onAdd();
        };

        this.label.draw = () => {
            this.draw();
        };

        this.label.onRemove = () => {
            this.onRemove();
        };

        this.setOverlay(this.label);
        this.createElements();

    }

    getLonLat() {
        var latLng = this.overlay.get('position');
        return [latLng.lng(), latLng.lat()];
    }


    delete() {
        super.delete();
        this.label.setMap(null);
        this.label = null;
        this.selectdiv.innerHTML = '';
        this.selectdiv.remove();
        this.selectdiv = null;
    }


    setColor(color) {
        super.setColor(color);
        if (this.selectdiv) {
            this.input.style.color = this.overlay.get('fontColor');
        }

        return this;
    }


    getProperties() {
        return {
            size: this.label.get('fontSize'),
            text: encodeURIComponent(this.label.get('text')),
            color: this.label.get('fontColor'),
        };
    }

    setProperties(propeties) {
        if (propeties.size) {
            this.label.set('fontSize', propeties.size);
        }
        if (propeties.text) {
            this.label.set('text', decodeURIComponent(propeties.text));
        }
        if (propeties.color) {
            this.label.set('fontColor', propeties.color);
        }
    }




    editable(editmode) {
        super.editable(editmode);
        if (this.selectdiv) {

            this.updateElements();
        }
    }

    updateElements() {
        this.selectdiv.style.background = this.editmode ? 'rgba(0, 0, 0, 0.075)' : 'transparent';
        this.input.style.display = this.editmode ? 'block' : 'none';
        this.controlsDiv.style.display = this.editmode ? 'block' : 'none';
        if (this.canvas) {
            this.canvas.style.display = this.editmode ? 'none' : 'block';
        }
        this.input.value = this.label.get('text');
        if (this.editable) {
            this.input.focus();
        }


    }


    changeSize(s: number) {
        this.label.set('fontSize', this.label.get('fontSize') + s);
        if (this.editable) {
            this.input.focus();
        }
    }




    createElements() {
        this.canvas = this.overlay.canvas_ = document.createElement('canvas');
        this.selectdiv = document.createElement('div');
        this.controlsDiv = document.createElement('div');

        this.selectdiv.style.textAlign = "center";
        this.controlsDiv.style.minWidth = "100px";

        this.input = document.createElement('input');
        this.input.onkeypress = (e) => {
            var code = (e.keyCode ? e.keyCode : e.which);

            this.label.set('text', this.input.value);
            this.drawCanvas_();
            if (code == 13) {
                this.parent.clearSelection();
            }
        };

        this.input.onchange = () => {
            if (this.input.value.length <= 0) {
                this.input.value = '';
            }
            this.label.set('text', this.input.value);
            this.drawCanvas_();
        };
        this.selectdiv.appendChild(this.input);
        this.input.style.display = "none";
        this.input.style.backgroundColor = "transparent";
        this.input.style.border = "none";
        this.input.style.outline = "none";
        this.input.style.lineHeight = "2em";
        this.input.style.fontWeight = "600";
        this.input.style.width = "100%";
        this.input.style.minWidth = "250px";
        this.selectdiv.style.minWidth = "250px";

        this.input.style.color = this.overlay.get('fontColor');
        this.input.style.font = this.overlay.get('fontSize') + 'px ' + this.overlay.get('fontFamily');


        var sizeUp = document.createElement('button');
        sizeUp.innerHTML = "<i class='glyphicon glyphicon-plus'></i>";
        sizeUp.classList.add('btn');
        sizeUp.addEventListener('click', (e) => {
            e.preventDefault();
            this.changeSize(+1);
            return false;
        });

        var sizeDown = document.createElement('button');
        sizeDown.innerHTML = "<i class='glyphicon glyphicon-minus'></i>";
        sizeDown.classList.add('btn');
        sizeDown.addEventListener('click', (e) => {
            e.preventDefault();
            this.changeSize(-1);
            return false;
        });


        this.controlsDiv.appendChild(sizeUp);
        this.controlsDiv.appendChild(sizeDown);
        this.selectdiv.appendChild(this.controlsDiv);

    }

    onAdd() {




        var style = this.canvas.style;
        style.position = 'absolute';


        var ctx = this.canvas.getContext('2d');
        ctx.lineJoin = 'round';
        ctx.textBaseline = 'top';

        this.drawCanvas_();

        var panes = this.overlay.getPanes();
        if (panes) {
            panes.markerLayer.appendChild(this.canvas);
            panes.overlayMouseTarget.appendChild(this.selectdiv);

            google.maps.event.addDomListener(this.selectdiv, 'click', (e) => {

                e.preventDefault();
                //google.maps.event.trigger(this.overlay, 'click', null);
                this.trigger('click', e);

                return false;
            });

            google.maps.event.addDomListener(this.selectdiv, 'mouseover', (e) => {
                e.preventDefault();
                //  google.maps.event.trigger(this.overlay, 'mouseover', e);
                return false;
            });

            google.maps.event.addDomListener(this.selectdiv, 'mousedown', (e) => {
                e.preventDefault();
                // google.maps.event.trigger(this.overlay, 'mousedown', e);
                return false;
            });
            google.maps.event.addDomListener(this.selectdiv, 'dragstart', (e) => {
                e.preventDefault();
                //  google.maps.event.trigger(this.overlay, 'dragstart', e);
                return false;
            });
            google.maps.event.addDomListener(this.selectdiv, 'mouseup', (e) => {
                e.preventDefault();
                //   google.maps.event.trigger(this.overlay, 'mouseup', e);
                return false;
            });

            this.addOverlayEvents();
        }

        this.updateElements();
    }


    /**
 * Draws the label to the canvas 2d context.
 * @private
 */
    drawCanvas_() {
        var canvas = this.label.canvas_;
        var clickdiv = this.selectdiv;
        if (!canvas) return;
        if (!clickdiv) return;

        var style = canvas.style;
        var clickdivstyle = clickdiv.style;
        style.zIndex = /** @type number */(this.label.get('zIndex'));

        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.strokeStyle = this.label.get('strokeColor');
        ctx.fillStyle = this.label.get('fontColor');

        var fontsize = this.label.get('fontSize');
        var font = fontsize + 'px ' + this.label.get('fontFamily');

        ctx.font = font;
        this.input.style.font = font;
        //     this.input.style.textAlign = this.label.get('align');

        var strokeWeight = Number(this.label.get('strokeWeight'));

        var text = this.label.get('text');
        if (text) {
            if (strokeWeight) {
                ctx.lineWidth = strokeWeight;
                ctx.strokeText(text, strokeWeight, strokeWeight);
            }

            ctx.fillText(text, strokeWeight, strokeWeight);

            var textMeasure = ctx.measureText(text);
            var textWidth = textMeasure.width + strokeWeight;
            var leftMargin = this.getMarginLeft_(textWidth);
            style.marginLeft = leftMargin + 'px';
            clickdivstyle.marginLeft = leftMargin + 'px';
            clickdivstyle.width = (textWidth + strokeWeight) + 'px';
            clickdivstyle.height = (fontsize * 2) + 'px ';

            // Bring actual text top in line with desired latitude.
            // Cheaper than calculating height of text.
            style.marginTop = '-1em';  //was -0.4em
            clickdivstyle.marginTop = '-1em';
            clickdivstyle.border = '0px';
        } else {
            clickdivstyle.border = '1px solid grey';
            clickdivstyle.minHeight = '1em';
            

        }


    };

    /**
    * @inheritDoc
    */
    draw() {
        var projection = this.label.getProjection();

        if (!projection) {
            // The map projection is not ready yet so do nothing
            return;
        }

        if (!this.label.canvas_) {
            // onAdd has not been called yet.
            return;
        }

        var latLng = /** @type {google.maps.LatLng} */ (this.label.get('position'));
        if (!latLng) {
            return;
        }
        var pos = projection.fromLatLngToDivPixel(latLng);

        var style = this.label.canvas_.style;

        style['top'] = pos.y + 'px';
        style['left'] = pos.x + 'px';
        style['visibility'] = this.getVisible_();

        var style2 = this.selectdiv.style;
        style2['top'] = pos.y + 'px';
        style2['left'] = pos.x + 'px';
        style2['position'] = 'absolute';


    };







    /**
     * Gets the appropriate margin-left for the canvas.
     * @private
     * @param {number} textWidth  the width of the text, in pixels.
     * @return {number} the margin-left, in pixels.
     */
    getMarginLeft_(textWidth) {
        switch (this.label.get('align')) {
            case 'left':
                return 0;
            case 'right':
                return -textWidth;
        }
        return textWidth / -2;
    };



    /**
     * Get the visibility of the label.
     * @private
     * @return {string} blank string if visible, 'hidden' if invisible.
     */
    getVisible_() {
        var minZoom = /** @type number */(this.label.get('minZoom'));
        var maxZoom = /** @type number */(this.label.get('maxZoom'));

        if (minZoom === undefined && maxZoom === undefined) {
            return '';
        }

        var map = this.label.getMap();
        if (!map) {
            return '';
        }

        var mapZoom = map.getZoom();
        if (mapZoom < minZoom || mapZoom > maxZoom) {
            return 'hidden';
        }
        return '';
    };

    /**
     * @inheritDoc
     */
    onRemove() {
        var canvas = this.label.canvas_;
        if (canvas && canvas.parentNode) {
            canvas.parentNode.removeChild(canvas);
        }
    };


}
